import { render } from "./HomeInspectionPlan.vue?vue&type=template&id=3b6e7032"
import script from "./HomeInspectionPlan.vue?vue&type=script&lang=js"
export * from "./HomeInspectionPlan.vue?vue&type=script&lang=js"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
